import React, { useEffect, useState } from "react";
import { FaCheck, FaFileExcel, FaTimes, FaCaretDown } from "react-icons/fa";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../utils/CONSTANTS";
import Header from "../../components/header";

const PendingOrderRegister = () => {

  const [filters, setFilters] = useState({
    // detailOf: 'Order Packing',
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    party: "",
  });

  const [data, setData] = useState([]);
  const [allparty, setparty] = useState([]);

  useEffect(() => {
    handleShow();
    fetchPartynames();
  }, []);

  const handleFilterChange = (name, value) => {
    console.log(name, value)
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleShow = async () => {
    console.log(filters);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/report/orderall`,
        {
          params: {
            startDate: filters.startDate,
            endDate: filters.endDate,
            party: filters.party || ""  // Send empty string if no party selected
          }
        }
      );

      if (response.status === 200) {
        let tempdata = []
        const orders = response.data.orders
        for (const ord of orders) {
          const cardno = ord.cardNo
          const res = await axios.get(
            `${API_BASE_URL}/api/package/getPackages/${cardno}`
          );
          let pkgqty = 0
          const packingdata = res.data.data
          if (packingdata.length) {
            for (const pkg of packingdata) {
              pkgqty += Number(pkg.totalquantity)
            }
          }
          tempdata.push({ ...ord, remainingqty: Number(ord.quantity) - pkgqty })
        }
        console.log(tempdata)
        setData(tempdata);
      } else {
        console.error("Failed to fetch data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchPartynames = async (req, res) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/order/getPartynames`,
        {
          withCredentials: true,
        }
      );

      const result = response.data.cardNos.map((item) => item);
      setparty(result);
    } catch (err) {
      console.log(err.message);
      toast("Some error occured, please try again later ");
    }
  };

  const handleExport = () => {
    const formattedData = data.map((row) => ({
      "V.No": row.cardNo,
      Date: row.date.split("T")[0],
      Party: row.partySpec,
      "Drg No.": row.drgNo,
      "Book Qty": row.quantity,
      "Balance Qty": row.remainingqty
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Order Register");

    XLSX.writeFile(workbook, "PendingOrderRegister.xlsx");
  };

  // Sorting state & logic
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!data) return [];
    const sortableItems = [...data];

    if (!sortConfig.key) return sortableItems;

    const key = sortConfig.key;
    const dir = sortConfig.direction;

    sortableItems.sort((a, b) => {
      const aVal = a?.[key] ?? "";
      const bVal = b?.[key] ?? "";

      // numeric values
      if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
        return dir === "asc" ? Number(aVal) - Number(bVal) : Number(bVal) - Number(aVal);
      }

      // date keys (common patterns)
      if (key.toLowerCase().includes("date")) {
        const ta = aVal ? new Date(aVal).getTime() : 0;
        const tb = bVal ? new Date(bVal).getTime() : 0;
        return dir === "asc" ? ta - tb : tb - ta;
      }

      // fallback string compare
      return dir === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });

    return sortableItems;
  }, [data, sortConfig]);

  return (
    <>
      <div className="bg-[#e6ffff] border border-gray-300 rounded shadow">
        {/* Header */}
        <div className="flex justify-between items-center px-2 py-1 border-b border-gray-300">
          <h2 className="text-sm font-semibold">Pending Order Register</h2>
          <div className="flex gap-1">
            <button className="p-0.5 hover:bg-gray-200 rounded">
              <FaTimes className="text-gray-600 w-3 h-3" />
            </button>
          </div>
        </div>

        {/* Filters */}
        <div className="grid grid-cols-5 gap-2 p-2 bg-[#e6ffff]">


          <div>
            <label className="block text-xs font-medium text-gray-700 mb-0.5">
              Start
            </label>
            <div className="relative">
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) =>
                  handleFilterChange("startDate", e.target.value)
                }
                className="w-full border rounded p-1 pr-6 text-xs"
              />
              <FaCaretDown className="absolute right-1.5 top-2 text-gray-400 w-2 h-2" />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-0.5">
              End
            </label>
            <div className="relative">
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) => handleFilterChange("endDate", e.target.value)}
                className="w-full border rounded p-1 pr-6 text-xs"
              />
              <FaCaretDown className="absolute right-1.5 top-2 text-gray-400 w-2 h-2" />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-0.5">
              Party
            </label>
            <div className="relative">
              <select
                value={filters.party}
                onChange={(e) => handleFilterChange("party", e.target.value)}
                className="w-full border rounded p-1 pr-6 appearance-none bg-white text-xs">
                <option value="">All Parties</option>  {/* <--- CHANGED TO THIS */}
                {allparty.map((value, index) => (
                  <option key={index} value={value} className="text-black">
                    {value}
                  </option>
                ))}
              </select>
              <FaCaretDown className="absolute right-1.5 top-2 text-gray-400 w-2 h-2" />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="p-2">
          <div className="border rounded bg-white">
            <table className="w-full text-xs overflow-x-auto">
              <thead>
                <tr className="border-b">
                  <th
                    onClick={() => handleSort("cardNo")}
                    className="border-r p-1 text-left font-medium cursor-pointer"
                  >
                    V.no {sortConfig.key === "cardNo" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                  </th>

                  <th
                    onClick={() => handleSort("date")}
                    className="border-r p-1 text-left font-medium cursor-pointer"
                  >
                    Date {sortConfig.key === "date" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                  </th>

                  <th
                    onClick={() => handleSort("partySpec")}
                    className="border-r p-1 text-left font-medium cursor-pointer"
                  >
                    Party {sortConfig.key === "partySpec" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                  </th>

                  <th
                    onClick={() => handleSort("drgNo")}
                    className="border-r p-1 text-left font-medium cursor-pointer"
                  >
                    Drg. No. {sortConfig.key === "drgNo" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                  </th>

                  <th
                    onClick={() => handleSort("quantity")}
                    className="border-r p-1 text-left font-medium cursor-pointer"
                  >
                    Book Qty {sortConfig.key === "quantity" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                  </th>

                  <th
                    onClick={() => handleSort("remainingqty")}
                    className="border-r p-1 text-left font-medium cursor-pointer"
                  >
                    Bal.Qty. {sortConfig.key === "remainingqty" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((row, index) => (
                  <tr key={index} className="border-b">
                    <td className="border-r p-1 text-left font-medium">{row.cardNo}</td>
                    <td className="border-r p-1 text-left font-medium">{row.date?.split("T")[0]}</td>
                    <td className="border-r p-1 text-left font-medium">{row.partySpec}</td>
                    <td className="border-r p-1 text-left font-medium">{row.drgNo}</td>
                    <td className="border-r p-1 text-left font-medium">{row.quantity}</td>
                    <td className="border-r p-1 text-left font-medium">{row.remainingqty}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-between p-2 bg-teal-600">
          <button
            onClick={handleShow}
            className="flex items-center gap-1 bg-white px-3 py-1 rounded hover:bg-gray-50 text-xs">
            <FaCheck className="text-green-600 w-3 h-3" />
            <span>Show</span>
          </button>

          <button
            onClick={handleExport}
            className="flex items-center gap-1 bg-white px-3 py-1 rounded hover:bg-gray-50 text-xs">
            <FaFileExcel className="text-green-600 w-3 h-3" />
            <span>Export to Excel</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default PendingOrderRegister;
